// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".carousel-base{overflow:hidden;position:relative;z-index:10}.carousel-base .carousel-slides-wrapper{display:inline-block;font-size:0;white-space:nowrap}.carousel-base .carousel-slides-wrapper>.slide{display:inline-block;white-space:normal}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
